import createUseMutation from '@Modules/App/Hooks/createUseMutation';
import api from "@Modules/Setting/services/api";

const useDeletePurchasingAccountMutation = createUseMutation({
    namespace: 'setting:purchasing_account.message.delete_account',
    mutation: id => api.deletePurchaseAccount(id),
});

export default useDeletePurchasingAccountMutation;